import ImageLink from './ImageLink';

export default function ThumbGallery({ heading, data, field, galleryID, path, apikey }) {
	if (!data[field]) return;
	return (
		<div className='tw-flex tw-flex-col tw-justify-end tw-grow'>
			{heading && <p className='tw-font-bold tw-mb-2 tw-text-sm'>{heading}</p>}
			<div className='tw-grid tw-gap-2 tw-grid-cols-[repeat(auto-fill,_minmax(6rem,_1fr))] tw-h-24 tw-overflow-hidden'>
				{data[field].split(';').map((item, i) => (
					<ImageLink
						key={i}
						thumbSrc={`${path.current}${item}?width=150&MODE=CROP&APIKEY=${apikey}`}
						src={`${path.current}${item}?width=600&MODE=CROP&APIKEY=${apikey}`}
						alt={`${data.Label}-${i + 1}`}
						galleryID={galleryID}
						icon='fas fa-expand fa-sm'
						iconPadding='tw-py-2.5 tw-px-2'
						twHeight='tw-h-24'
						rounded='tw-rounded'
					/>
				))}
			</div>
		</div>
	);
}
